import React from "react";

function BS4_GridLarge() {
  return (
    <div>
      <h1>BS4_GridLarge Component</h1>
      <p>This is the BS4_GridLarge tutorial page content.</p>
    </div>
  );
}

export default BS4_GridLarge;
